import { render, staticRenderFns } from "./PopupDispatcher.vue?vue&type=template&id=db24735c&scoped=true&lang=pug&"
import script from "./PopupDispatcher.vue?vue&type=script&lang=js&"
export * from "./PopupDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db24735c",
  null
  
)

export default component.exports